import { cn } from '@/lib/utils';

export const ServiceStatusIcon = ({
  status,
  classNames,
}: {
  status: 'success' | 'error';
  classNames?: { inner?: string; outer?: string };
}) => {
  const outerColor = status === 'success' ? 'bg-success-700' : 'bg-error-700';
  const innerColor = status === 'success' ? 'bg-success-500' : 'bg-error-600';

  return (
    <div className={cn('h-4 w-4 rounded-full', outerColor, classNames?.outer)}>
      <div
        className={cn(
          'm-1 h-2 w-2 rounded-full',
          innerColor,
          classNames?.inner
        )}
      />
    </div>
  );
};
